import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import LevelOfService from "../../components/Transportation/LevelOfService/LevelOfService";
import { useTripsCtx } from "../../context/TripDetailsContext";
import {
  CostDetails,
  DefaultLosCharges,
  ILosCharges,
} from "../../types/TripTypes";

interface IParams {
  ride: string;
}

const LevelOfServiceContainer = () => {
  const [losCharges, setLosCharges] = useState<ILosCharges>(DefaultLosCharges);

  const { tripSetupDetailsCtx } = useTripsCtx();
  const [tripCreationDetails] = tripSetupDetailsCtx;

  const { ride } = useParams<IParams>();

  useEffect(() => {
    let charges: ILosCharges = DefaultLosCharges();
    let vehicleType =
      ride === CostDetails.WavRide
        ? CostDetails.WandaWav
        : CostDetails.WandaStandard;
    if (tripCreationDetails.length !== 0) {
      let losCharges = tripCreationDetails[0]?.WandaCostDetail?.find(
        (x: { planName: string }) => x.planName === vehicleType
      );
      charges.losDoorToDoor =
        ride === CostDetails.WavRide ? 0 : losCharges?.losDoorToDoor;
      charges.losPersonToPerson =
        ride === CostDetails.WavRide ? 0 : losCharges?.losPersonToPerson;
      charges.losPersonToPersonWav =
        ride === CostDetails.WavRide ? losCharges?.losPersonToPerson : 0;
    }
    setLosCharges(charges);
  }, []);

  return <LevelOfService losCharges={losCharges} />;
};
export default LevelOfServiceContainer;
